import { Corpus_$ctor_64685318 } from "../../../../fs/Model/Model.js";
import { quickView, selectionTable, menu } from "./Metadata.js";

export function getCorpus(config) {
    return Corpus_$ctor_64685318(config, void 0, menu, selectionTable, quickView);
}

